import { useMutation } from 'react-query';
import { JsonObject } from 'type-fest';

import { useRequest, type MutationFunction } from '../common';

export type CustomWorkflowStepStatusUpdate = {
  id: string;
  status: string | undefined;
};

export type UseBulkUpdateWorkflowsRequestVars = {
  quoteId: number;
  quoteItems: number[];
  components: number[];
  workflowStatus: string | undefined;
  customWorkflowSteps: CustomWorkflowStepStatusUpdate[];
  applyToChildComponents: boolean;
} & JsonObject;

export type UseBulkUpdateWorkflowsData = Array<{
  id: number;
  workflowStatus: string;
  componentWorkflowStatuses: Record<number, string>;
  workflowSteps: Record<any, any>;
}>;

export const useBulkUpdateWorkflows: MutationFunction<
  UseBulkUpdateWorkflowsData,
  UseBulkUpdateWorkflowsRequestVars
> = ({ query, requestOptions, queryOptions } = {}) => {
  const request = useRequest(requestOptions);
  return useMutation(
    ({ quoteId, ...body }) =>
      request(`/quotes/${quoteId}/bulk_update_workflows`, {
        query,
        init: {
          method: 'PATCH',
          body,
        },
      }),
    queryOptions,
  );
};
